import dynamic from 'next/dynamic';
import {NextPageContext} from "next";
import { getLatestTncContent } from 'data/store';

const DefaultTheme = dynamic(() => import('./_default'));
const Meta = dynamic(() => import('components/Meta/_default'));
const FullPageLayout = dynamic(() => import('components/Layout/FullPageLayout/_default/FullPageLayout'));

interface Props {
  tncDetails: any;
  isError: boolean;
  error: any;
}

const B2bTnCPage = (props: Props) => (
  <>
    <Meta
      title='Buyers Agreement'
      urlPath='tnc/b2b/buyers-agreement'
    />
    <DefaultTheme {...props}/>
  </>
);

export const getServerSideProps = async (ctx: NextPageContext) => {
  try {
    const tncDetails = await getLatestTncContent({
      storeType: 'b2b',
      entityType: 'dropshipper',
      tncPage: 'dropshipperBuyersAgreement',
    }, ctx);
  
    return {
      props: {
        tncDetails,
        isError: false,
        error: {},
      }
    };
  } catch (err) {
    return {
      props: {
        tncDetails: {},
        isError: true,
        error: {
          response: err.response.data,
          status: err.response.status,
          statusText: err.response.statusText,
        },
      }
    };
  }
};

B2bTnCPage.getLayout = (page: React.ReactElement) => <FullPageLayout wrapperClass="!bg-[white]">{page}</FullPageLayout>

export default B2bTnCPage;
